// extracted by mini-css-extract-plugin
export default {"image":"I3-z","loaded":"J3-z","placeholder":"K3-z"};